// Deterministic, system-generated colors for VOD folders.
// Per design spec:
//  - normal folders get a random (but stable) solid color
//  - live-to-vod folders get a gradient color
//  - colors are derived from the folder id so they never change and
//    two different folders effectively never share the same color
//  - colors are not user-editable

function hashString(str = '') {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0; // keep 32-bit
  }
  return Math.abs(hash);
}

export function folderHue(id = '') {
  return hashString(String(id)) % 360;
}

export function folderSolidColor(id = '') {
  const h = folderHue(id);
  return `hsl(${h}deg 52% 62%)`;
}

export function folderGradient(id = '') {
  const h = folderHue(id);
  const h2 = (h + 26) % 360;
  return `linear-gradient(157deg, hsl(${h}deg 56% 64%) 0%, hsl(${h2}deg 46% 40%) 100%)`;
}

// Returns a CSS background value (solid color or gradient) for a folder object.
export function folderBackground(folder) {
  if (!folder) return folderSolidColor('');
  const id = folder._id || folder.id || folder.name || '';
  return folder.liveParent ? folderGradient(id) : folderSolidColor(id);
}

export function folderInitial(folder) {
  const name = (folder?.name || '').trim();
  return name ? name.charAt(0).toUpperCase() : '#';
}

// Calmer, enterprise treatment: a dark, subtly-tinted tile with a legible
// colored folder glyph — keeps per-folder identity without the loud, fully
// saturated letter tiles.
export function folderIconColor(id = '') {
  const h = folderHue(id);
  return `hsl(${h}deg 65% 74%)`;
}

export function folderTintBackground(id = '') {
  const h = folderHue(id);
  return `hsl(${h}deg 34% 25%)`;
}

export function folderTint(folder) {
  if (!folder) return { bg: folderTintBackground(''), fg: folderIconColor('') };
  const id = folder._id || folder.id || folder.name || '';
  return { bg: folderTintBackground(id), fg: folderIconColor(id) };
}
